import { defineStore } from "pinia";
import { usePartnerStore } from "@/stores/partner";
import { useSessionStore } from "@/stores/session";

export const usePiniaStore = defineStore("store", () => {
    const sessionStore = useSessionStore();
    const partnerStore = usePartnerStore();

    function clearUserSession() {
        sessionStore.clearUserSession();
        partnerStore.clearPartnerProfile();
    }

    return { clearUserSession };
});

export { useDateRangeStore } from "@/stores/dateRange";
export { usePartnerStore } from "@/stores/partner";
export { useSessionStore } from "@/stores/session";
